import { AnimatePresence, motion } from "framer-motion";
import { X, Phone } from "lucide-react";
import { NAV, SITE } from "@/data/site";
import { Logo } from "@/components/header/Logo";

const MobileNavItem = ({ item, index, onGo }) => (
    <motion.button
        type="button"
        data-testid={`mobile-nav-link-${item.id}`}
        onClick={() => onGo(item)}
        className="flex items-baseline gap-4 py-3 text-left"
        initial={{ opacity: 0, x: -24 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.08 * index, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    >
        <span className="font-mono-tl text-xs text-tl-orange">0{index + 1}</span>
        <span className="font-display text-3xl font-bold tracking-tight text-white">{item.label}</span>
    </motion.button>
);

export const MobileMenu = ({ open, onClose, onGo }) => (
    <AnimatePresence>
        {open && (
            <motion.div
                data-testid="mobile-menu"
                className="fixed inset-0 z-50 flex flex-col bg-tl-dark3"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
            >
                <div className="flex h-[72px] items-center justify-between px-4 sm:px-6">
                    <Logo onClick={() => onGo("home")} />
                    <button
                        type="button"
                        data-testid="mobile-menu-close"
                        onClick={onClose}
                        className="grid h-11 w-11 place-items-center border border-white/15 text-white"
                        aria-label="Chiudi menu"
                    >
                        <X size={20} />
                    </button>
                </div>
                <nav className="flex flex-1 flex-col justify-center gap-2 px-8">
                    {NAV.map((item, i) => (
                        <MobileNavItem key={item.id} item={item} index={i} onGo={onGo} />
                    ))}
                </nav>
                <div className="space-y-3 px-8 pb-10">
                    <button
                        type="button"
                        data-testid="mobile-quote-button"
                        onClick={() => onGo("contatti")}
                        className="w-full bg-tl-orange py-4 font-mono-tl text-sm font-semibold uppercase tracking-[0.15em] text-tl-dark"
                    >
                        Richiedi un preventivo
                    </button>
                    <a
                        data-testid="mobile-call-now-button"
                        href={SITE.phoneHref}
                        className="flex w-full items-center justify-center gap-2 border border-white/20 py-4 font-mono-tl text-sm uppercase tracking-[0.15em] text-white"
                    >
                        <Phone size={16} /> Chiama ora — {SITE.phoneDisplay}
                    </a>
                </div>
            </motion.div>
        )}
    </AnimatePresence>
);
